// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"33b5ed30","368":"d885aa0f","480":"4d61d882","481":"341fbad4","629":"8855a560","715":"df5bf32d","836":"05ed9dcb","965":"c71f9fbc","989":"3366fa5d"}[chunkId] + ".css";
};